import styled from 'styled-components'

const Layout = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 24px 0;
`;

export default Layout